<template>
  <div class="curriculum app-content">
    <div class="curriculum-head head-box">
      <span>当前位置： </span>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/">发现课程</a></el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="curriculum-content">
      <div class="content-title">
        <div class="title">技能工种</div>
        <ul class="content-list">
          <li :class="active == 'all' ? 'active-box' : ''" @click="changeCur('all', '')">全部</li>
          <li v-for="(item,key) in curriculum" :key="key" :class="active == key ? 'active-box' : ''" @click="changeCur(key, item.olCatgoryId)">{{item.olCatgoryName}}</li>
        </ul>
      </div>
      <div class="content-title" v-if="active != 'all' && curriculum[active]">
        <div class="title">工种级别</div>
        <ul class="content-list">
          <li :class="activeI == 'all' ? 'active-box' : ''" @click="changeCurI('all', '')">全部</li>
          <li v-for="(item,key) in curriculum[active].curriculums" :key="key" :class="activeI == key ? 'active-box' : ''" @click="changeCurI(key, item.olCurriculumId)">{{item.olCurriculumName}}</li>
        </ul>
      </div>
      <div class="content-title">
        <div class="title">授课方式</div>
        <ul class="content-list">
          <li :class="curType == '1' ? 'active-box' : ''" @click="changeType('1')">全部</li>
          <li :class="curType == '3' ? 'active-box' : ''" @click="changeType('3')">录播</li>
          <li :class="curType == '2' ? 'active-box' : ''" @click="changeType('2')">直播</li>
          <li :class="curType == '4' ? 'active-box' : ''" @click="changeType('4')">面授</li>
          <li :class="curType == '5' ? 'active-box' : ''" @click="changeType('5')">一对一约课</li>
          <li :class="curType == '6' ? 'active-box' : ''" @click="changeType('6')">其他</li>
        </ul>
      </div>
    </div>
    <div class="curriculum-body">
      <div class="titleI">全部课程</div>
      <cur-list v-if="currList.length > 0" :curriculumData="currList"></cur-list>
      <div class="noList" v-else>暂无课程</div>
      <pagination :total="currData.totalCount" :currentPage="page" :pageSize=8 :currentChange="currentChange"></pagination>
    </div>
  </div>
</template>

<script>
// import axios from 'axios'
import curList from '../components/curList'
import pagination from '../components/pagination'
// const curriculum11 = require('../../mock/curriculum.json')
// const curriculumData = require('../../mock/curriculumData.json')

export default {
  name: 'curriculum',
  components: {
    curList,
    pagination
  },
  data () {
    return {
      curriculum: [],
      active: 'all',
      curType: '1',
      activeI: 'all',
      currList: [],
      currData: '',
      catgory: '',
      //  类别id
      olCatgoryId: '',
      //  课程id
      olCurriculumId: '',
      page: 1
    }
  },
  mounted () {
    this.getData()
    this.getCurList(1)
  },
  methods: {
    // 获取学科数据
    getData () {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olcurriculum/olCatgoryInfos'
      }).then((result) => {
        that.curriculum = result.data.data
      })
    },
    // 获取课程列表
    getCurList (page) {
      let that = this
      this.$http({
        method: 'get',
        url: '/api/renren-fast/app/olcurriculum/indexList',
        // url: '/api/renren-fast/app/olcurriculumstagemx/list',
        params: {
          'page': page,
          'limit': 8,
          'olCatgoryId': this.olCatgoryId,
          'olCurriculumId': this.olCurriculumId
        }
      }).then((result) => {
        if (result.data.code === 0) {
          that.currList = result.data.page.olCurriculum
          this.currData = result.data.page
        }
      })
    },
    //  选择学科大类
    changeCur (key, id) {
      this.active = key
      this.activeI = 'all'
      this.olCatgoryId = id
      this.olCurriculumId = ''
      this.page = 1
      this.getCurList(1)
    },
    // 收款小类选择
    changeCurI (key, id) {
      this.activeI = key
      this.olCurriculumId = id
      this.page = 1
      this.getCurList(1)
    },
    //   选择授课方式
    changeType (key) {
      this.curType = key
    },
    currentChange (val) {
      this.page = val
      this.getCurList(val)
    }
  },
  watch: {
    $route (to, from) {
      this.olCatgoryId = to.query.olCatgoryId ? to.query.olCatgoryId : ''
      this.olCurriculumId = to.query.olCurriculumId ? to.query.olCurriculumId : ''
      this.active = to.query.key ? to.query.key : 'all'
      this.activeI = to.query.keys ? to.query.keys : 'all'
      this.page = 1
      this.getCurList(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.curriculum{
  width: 100%;
  .curriculum-head{
    width: 1200px;
    margin: 0px auto;
  }
  .curriculum-content{
    width: 1200px;
    margin: 20px auto 0px;
    border-top: 1px solid #ddd;
    padding-top: 15px;
    .content-title{
      display: flex;
      border-bottom: 1px solid #ddd;
      padding: 15px 0px 5px 0px;
      .title{
        font-size: 18px;
        font-weight: bold;
        width: 110px;
        flex-shrink: 0;
      }
      .content-list{
        display: flex;
        flex-wrap: wrap;
        li{
          margin-right: 30px;
          height: 24px;
          line-height: 24px;
          margin-bottom: 10px;
          cursor: pointer;
          padding: 0px 15px;
        }
      }
    }
    .active-box{
      background: #ce443a;
      color: #fff;
    }
  }
  .curriculum-body{
    width: 1200px;
    margin: 0px auto;
    .titleI{
      font-size: 24px;
      font-weight: bold;
      color: #666;
      padding: 20px 0px;
    }
    .noList{
      width: 100%;
      height: 300px;
      text-align: center;
      line-height: 300px;
      font-size: 18px;
      color: #999999;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/curriculum.vue